// extracted by mini-css-extract-plugin
module.exports = {"filterTagButton":"styles_filterTagButton__12SAA","filterTagButtonHovered":"styles_filterTagButtonHovered__2_LK1","closeIcon":"styles_closeIcon__21mrS"};